module.exports = __webpack_public_path__ + "img/Avatar-56.1aa6d951.svg";